import React from 'react';
import { useIntl, defineMessages } from 'react-intl';
import PropTypes from 'prop-types';

const i18n = defineMessages({
  lockedOut: {
    id: 'login.locked_out',
    defaultMessage: 'You are currently locked out due to several failed attempts. Try again in a few minutes.',
  },
});

const LockedOut = ({ timeUntilLockoutExpiration }) => {
  const { formatMessage } = useIntl();

  const minutes = Math.floor((timeUntilLockoutExpiration % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((timeUntilLockoutExpiration % (1000 * 60)) / 1000);

  const minutesToDisplay = minutes < 10 ? `0${minutes}` : `${minutes}`;
  const secondsToDisplay = seconds < 10 ? `0${seconds}` : `${seconds}`;

  const remainingTime = `${minutesToDisplay}:${secondsToDisplay}`;

  return (
    <div>
      <div className="p-grid p-fluid p-justify-center logo-top">
        <img src="images/default-195.png" className="brand center-block" alt="GPI Logo" />
      </div>
      <div className="p-grid p-fluid p-justify-center">
        <div className="locked-out">{formatMessage(i18n.lockedOut)}</div>
      </div>
      <div className="p-grid p-fluid p-justify-center">
        <div className="locked-out">{remainingTime}</div>
      </div>
    </div>
  );
};

LockedOut.propTypes = {
  timeUntilLockoutExpiration: PropTypes.string.isRequired,
};

export default LockedOut;
